import { takeLatest, call, put } from 'redux-saga/effects';
import axiosInstance from '../../services/AuthHeader';
import { setRegisterError } from '../reducers/authorization';
import { setSending, unsetSending } from '../reducers/serverCommunication';
import { userSignedInAction } from './userSignedInSaga';

export const SAGA_REGISTER = 'SAGA_REGISTER';

export function registerSaga(payload) {
  return { type: SAGA_REGISTER, payload };
}

const handleRegister = async ({
  email,
  password,
  nickname,
  birthYear,
  province,
  phoneNumber,
  language,
}) =>
  axiosInstance
    .post('/api/pop/register', {
      email,
      username: email,
      password,
      nickname,
      birthYear,
      province,
      phoneNumber,
      language,
    })
    .then((res) => res.data);

export function* register(action) {
  yield put(setSending);
  try {
    const response = yield call(handleRegister, action.payload);
    yield put(userSignedInAction(response));
  } catch (error) {
    if (error.response?.data?.errors) {
      yield put(setRegisterError(error.response.data.errors[0]));
    }
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForRegister() {
  yield takeLatest(SAGA_REGISTER, register);
}
